<template>
    <b-container>
        <b-card header="Resumen">
            <b-card-text>
                <table class="table table-bordered table-sm table-striped">
                    <thead>
                        <tr>
                            <th>Supervisor</th>
                            <th>Bono Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="item in resume"
                            v-if="
                                user.profile.slug !== 'supervisor' ||
                                item.id === user.id
                            "
                        >
                            <td>
                                <a
                                    href="#"
                                    size="sm"
                                    variant="link"
                                    @click.prevent="
                                        $emit('scroll-to', `user-${item.id}`)
                                    "
                                    >{{ item.name }}</a
                                >
                            </td>
                            <td>${{ item.bonus | currency }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-card-text>
        </b-card>
    </b-container>
</template>
<script>
export default {
    props: {
        users: {
            type: Array,
            default: [],
        },
    },
    data: () => ({}),
    computed: {
        resume() {
            const bonuses = this.users.map((item) => ({
                id: item.id,
                name: item.name,
                bonus: item.supervisor_goal_bonuses.reduce(
                    (acum, result) => acum + result.bonus,
                    0
                ),
            }))
            return bonuses
        },
    },
    methods: {},
}
</script>
